// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"5be6452f","332":"adbf4d06"}[chunkId] + ".chunk.css";
};